import axios from 'axios';
import { STATUS_CODES, METHODS } from '@app/constants/api';
import { TOKEN_NAME } from '@app/constants/global.const';
import { saveAs } from 'file-saver';

const config = () => {
    const token = localStorage.getItem(TOKEN_NAME);
    const headers = {
        'Access-Control-Allow-Origin': '*',
        'Access-Control-Allow-Headers': '*',
        Authorization: `Bearer ${token}`,
    };
    return headers;
};

const formConfig = () => {
    const token = localStorage.getItem(TOKEN_NAME);
    const headers = {
        'Content-Type': 'multipart/form-data',
        'Access-Control-Allow-Origin': '*',
        'Access-Control-Allow-Headers': '*',
        Authorization: `Bearer ${token}`,
    };
    return headers;
};

class AxiosService {
    // ========== Các hàm gốc (không withCredentials) ==========
    get = (url, type, timeOut) =>
        this.doRequest(METHODS.GET, url, '', type, timeOut);

    post = (url, data, type, timeOut) =>
        this.doRequest(METHODS.POST, url, data, type, timeOut);

    put = (url, data, type, timeOut) =>
        this.doRequest(METHODS.PUT, url, data, type, timeOut);

    delete = (url, type, timeOut) =>
        this.doRequest(METHODS.DELETE, url, '', type, timeOut);

    exportExcel = (url, dataPost) => {
        const instance = axios.create();
        const options = {
            url,
            method: METHODS.POST,
            data: dataPost,
            headers: config(),
            responseType: 'blob',
        };
        return instance.request(options).then((response) => {
            const resHeader = response.headers['content-disposition'];
            if (resHeader) {
                const filename = resHeader
                    .split(';')
                    .find((n) => n.includes('filename='))
                    .replace('filename=', '')
                    .trim();
                const blob = new Blob([response.data]);
                // const urlFile = window.URL.createObjectURL(blob);

                saveAs(blob, filename);
            }
        });
    };

    doRequest = (method, url, data, type, timeOut) => {
        let cusConfig = config();
        if (type === 'FORM') {
            cusConfig = formConfig();
        }
        if (process.env.NODE_ENV === 'production') {
            timeOut = timeOut || 0;
        } else {
            timeOut = 0;
        }

        return axios({
            method,
            url,
            data,
            headers: cusConfig,
            timeout: timeOut,
        })
            .then((res) => res)
            .catch((err) => {
                const resp = err.response;
                if (!resp) {
                    return {
                        status: 503,
                        data: {
                            msg: 'Không kết nối được đến network',
                        },
                    };
                }
                switch (resp.status) {
                    case STATUS_CODES.NOT_FOUND:
                    case STATUS_CODES.METHOD_NOT_ALLOW:
                    case STATUS_CODES.SERVICE_UNAVAIBLE:
                    case STATUS_CODES.BAD_REQUEST: {
                        return resp;
                    }
                    case STATUS_CODES.UNAUTHORIZED: {
                        const hadToken = !!localStorage.getItem(TOKEN_NAME);
                        localStorage.setItem(TOKEN_NAME, '');
                        if (
                            window.location.pathname.includes(
                                '/session-expired',
                            ) ||
                            window.location.pathname.includes('/login')
                        ) {
                            return '';
                        }
                        // Có token nhưng hết hạn → trang session-expired
                        // Không có token (chưa đăng nhập) → trang login
                        window.location.href = hadToken
                            ? '/session-expired'
                            : '/login';
                        return '';
                    }
                    default:
                        return resp;
                }
            });
    };

    // ========== Các hàm mới (có withCredentials) ==========
    // Gửi kèm cookie httpOnly để server xác thực origin

    secureGet = (url, type, timeOut) =>
        this.doSecureRequest(METHODS.GET, url, '', type, timeOut);

    securePost = (url, data, type, timeOut) =>
        this.doSecureRequest(METHODS.POST, url, data, type, timeOut);

    secureDelete = (url, type, timeOut) =>
        this.doSecureRequest(METHODS.DELETE, url, '', type, timeOut);

    secureExportExcel = (url, dataPost) => {
        const instance = axios.create();
        const options = {
            url,
            method: METHODS.POST,
            data: dataPost,
            headers: config(),
            responseType: 'blob',
            withCredentials: true,
        };
        return instance.request(options).then((response) => {
            const resHeader = response.headers['content-disposition'];
            if (resHeader) {
                const filename = resHeader
                    .split(';')
                    .find((n) => n.includes('filename='))
                    .replace('filename=', '')
                    .trim();
                const blob = new Blob([response.data]);
                saveAs(blob, filename);
            }
        });
    };

    doSecureRequest = (method, url, data, type, timeOut) => {
        let cusConfig = config();
        if (type === 'FORM') {
            cusConfig = formConfig();
        }
        if (process.env.NODE_ENV === 'production') {
            timeOut = timeOut || 0;
        } else {
            timeOut = 0;
        }

        return axios({
            method,
            url,
            data,
            headers: cusConfig,
            timeout: timeOut,
            withCredentials: true,
        })
            .then((res) => res)
            .catch((err) => {
                const resp = err.response;
                if (!resp) {
                    return {
                        status: 503,
                        data: {
                            msg: 'Không kết nối được đến network',
                        },
                    };
                }
                switch (resp.status) {
                    case STATUS_CODES.NOT_FOUND:
                    case STATUS_CODES.METHOD_NOT_ALLOW:
                    case STATUS_CODES.SERVICE_UNAVAIBLE:
                    case STATUS_CODES.BAD_REQUEST: {
                        return resp;
                    }
                    case STATUS_CODES.UNAUTHORIZED: {
                        const hadToken = !!localStorage.getItem(TOKEN_NAME);
                        localStorage.setItem(TOKEN_NAME, '');
                        if (
                            window.location.pathname.includes(
                                '/session-expired',
                            ) ||
                            window.location.pathname.includes('/login')
                        ) {
                            return '';
                        }
                        window.location.href = hadToken
                            ? '/session-expired'
                            : '/login';
                        return '';
                    }
                    default:
                        return resp;
                }
            });
    };
}
export default new AxiosService();
